import {withTableHead} from './withTableHead';
import {TableHeadStyle} from './TableHeadStyle';

/**
 * Represents table header group. Typically contains row with column names.
 * Also makes table cells render as `th` elements instead of `td` elements.
 *
 * @component
 */
export const TableHead = withTableHead(TableHeadStyle);
